import { useId, useCallback } from 'react'
import { formatMoneyInput, parseMoneyInput } from '@utils/format.js'

interface Props {
  name?: string
  label?: string
  value: number
  placeholder?: string
  required?: boolean
  disabled?: boolean
  hint?: string
  error?: string
  onChange: (value: number) => void
}

export function MoneyInput({
  name,
  label,
  value,
  placeholder = '0,00',
  required = false,
  disabled = false,
  hint = '',
  error = '',
  onChange,
}: Props) {
  const id = useId()
  const display = value > 0 ? formatMoneyInput(value) : ''

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(parseMoneyInput(e.target.value))
    },
    [onChange],
  )

  return (
    <div className={`cf-field${error ? ' cf-field--error' : ''}`}>
      {label && (
        <label className='cf-field__label' htmlFor={id}>
          {label}
          {required && (
            <span className='cf-field__required' aria-hidden>
              {' '}
              *
            </span>
          )}
        </label>
      )}
      <div className='cf-field__input-wrap'>
        <span className='cf-field__prefix' aria-hidden>
          R$
        </span>
        <input
          className='cf-field__input'
          id={id}
          name={name}
          type='text'
          inputMode='decimal'
          placeholder={placeholder}
          value={display}
          required={required}
          disabled={disabled}
          aria-describedby={hint || error ? `${id}-hint` : undefined}
          aria-invalid={error ? true : undefined}
          onChange={handleChange}
        />
      </div>
      <span className='cf-field__hint' id={`${id}-hint`}>
        {error || hint}
      </span>
    </div>
  )
}
